import Holidays from 'date-holidays';
import dayjs, { OpUnitType } from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

// https:day.js.org/docs/en/display/format

export const UI_DATE_FORMAT_STRING = 'MMM D, YYYY'; // used for showing dates for users
export const UI_DATE_TIME_FORMAT_STRING = 'MMM D YYYY, h:mm a'; // used for showing date time for users
export const UI_TIME_FORMAT_STRING = 'h:mm a'; // used for showing time for users
export const DATE_FORMAT_STRING = 'MM/DD/YYYY';
export const DB_DATE_FORMAT_STRING = 'YYYY-MM-DD';
export const DB_DATETIME_FORMAT_STRING = 'YYYY-MM-DD HH:mm';

export const parseDate = (date: string, format: string = `${DATE_FORMAT_STRING}, hh:mm a`): string => {
  return dayjs(date).format(format);
};

export const parseDateNoTime = (date: string): string => {
  return parseDate(date, DATE_FORMAT_STRING);
};

export const parseTimeTo = (timeTo: string): string => {
  return timeTo === '0:00' ? '23:59:59' : timeTo;
};

export const getHourFormatted = (hour: string): string => {
  return dayjs(`2000-01-01 ${hour}`, DB_DATETIME_FORMAT_STRING).format('h:mma');
};

export const parseTime = (datetime: string, format: string = UI_DATE_TIME_FORMAT_STRING): string => {
  return parseDate(datetime, format);
};

export const getDBDate = (date: dayjs.Dayjs): string => {
  return date.format(DB_DATE_FORMAT_STRING);
};

export const getUSHolidays = (year: number = dayjs().year()): string[] => {
  return new Holidays('US', 'DC', { types: ['public'] }).getHolidays(year).map((o) => o.date.split(' ')[0]);
};

export const getUSHolidaysSafe = (): string[] => {
  const currentYear = getUSHolidays();
  const nextYear = getUSHolidays(dayjs().add(1, 'year').year());
  return [...currentYear, ...nextYear];
};

export const getHour = (hour: string): dayjs.Dayjs => {
  return dayjs(`2000-01-01 ${hour}`, DB_DATETIME_FORMAT_STRING);
};

export const isSameDates = (date1: string, date2: string, unit: OpUnitType = 'day'): boolean => {
  return dayjs(date1).isSame(dayjs(date2), unit);
};

export const getDuration = (timestamp: number): string => {
  const d = dayjs.duration(timestamp);

  const months = d.months();
  const days = d.days();
  const hours = d.hours();
  const minutes = d.minutes();

  if (months > 0) {
    return `${months}m ${days}d ${hours}h ${minutes}m`;
  }

  return `${days}d ${hours}h ${minutes}m`;
};
